import { FormattedMessage } from 'react-intl';
import { PoolSelect, SelectOption, useFilter } from '@synergy/components';

import { ImportReceptionType } from '../../models/import-supplier';

const receptionTypeOptions = Object.values(ImportReceptionType).map<SelectOption>(setting => ({
    value: setting,
    displayValue: <FormattedMessage id={`app.enum.importReceptionType.${setting}`} />,
}));

export const ReceptionTypeFilter = () => {
    const { filter, updateFilter, registerFilterMap } = useFilter();

    const onSelected = (value?: string) => {
        filter.delete('importReceptionType');
        if (value !== undefined && value !== null) {
            filter.set('importReceptionType', value);
        }
        updateFilter(filter);
    };

    registerFilterMap('importReceptionType', typeValue => {
        const type = receptionTypeOptions.find(option => option.value.toString() === typeValue);
        return type?.displayValue;
    });

    return (
        <PoolSelect
            displayEmpty={true}
            name="importReceptionType"
            label={<FormattedMessage id="app.imports.suppliersTable.importReceptionType" />}
            fullWidth={true}
            value={filter.get('importReceptionType')}
            onValueChange={onSelected}
            options={receptionTypeOptions}
            noSorting={true}
        />
    );
};
